import React, {Component} from 'react';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import { Button } from 'reactstrap';
import { sendCreateAccountCode, isValidEmail, isValid, isValidPassword, authenticate, stopTimer, register, putToast} from "../api";
import Breadcrumb from "../common/breadcrumb";
import queryString from "query-string";
import ModalWindow from '../common/modalWindow'

//const PMPID = process.env.REACT_APP_PRIME_MEMBERSHIP_PRODUCT_ID;

class Register extends Component {

    constructor (props) {
        super(props);
        const value=queryString.parse(this.props.location.search);
        this.getApprovableCode = this.getApprovableCode.bind(this);
        this.getApprovableSubmit = this.getApprovableSubmit.bind(this);
        this.reasons = [];

        this.state = {
            loading: true,
            openId: value.oid,
            open: value.oid ? true : false,
            em: value.em ? value.em : "",
            shouldGotoMembership: false,
            accountType: null
        }
    }

    onCancel = () => {
        this.setState({open: false});
    };

    onValidSubmit = (event, values) => {
        if (!values.password || !values.email) return;
        if (values.password.trim() !== values.confirmPassword.trim()) return;
        values.fullname = `${values.firstname.trim()} ${values.lastname.trim()}`;
        values.displayname = values.fullname.trim();
        values.accountType = this.state.accountType;
        values.email = this.state.email.toLowerCase().trim();

        if (values.confirmationcode) { // we have a code so we are creating account
            values.confirmationcode = this.state.confirmationcode.toLowerCase().trim();
            register(values).then(data => {
                if (data.error) {
                    console.log(data.error);
                    putToast.error(data.error);
                } else {
                    authenticate(data, () => {
                        this.props.history.push(`${process.env.PUBLIC_URL}`);
                        this.props.onHeaderDataChanged();
                        putToast.success("Account Created");

                    });
                }
            }); 
        } else { // no code so we are sending code
            sendCreateAccountCode(values.email).then(d2 => {
                console.log(d2)
                if (d2 && d2.error) {
                    console.log(d2.error);
                    putToast.error(d2.error)
                } else {
                    putToast.success(d2.message)
                    this.setState({ data: d2, isReceiving: true, loading: false});                    
                }
            });             
        }   
    };
    
    onInvalidSubmit = (event, errors, values) => {
        //this.setState({errors, values});
    };

    handleChange = (e) => {
        this.setState({[e.target.name]: e.target.value})
    }

    isValid(value) {
        if (typeof value === 'undefined') return false;
        value = value.trim();
        return !( value === "" || !  /$/.test(value))
    }

    approveItem(item, message) {
        if (item) return true;
        
        this.reasons.push(message)
        return false;
    }

    getApprovableCode(state) {
        var approvable = true;

        if (state) {
            this.reasons = [];

            approvable &= this.approveItem(isValid(state.firstname), "Please enter valid first name.")
            approvable &= this.approveItem(isValid(state.lastname), "Please enter valid last name.")
            approvable &= this.approveItem(isValidEmail(state.email), "Please enter valid email address.")
            approvable &= this.approveItem(isValidPassword(state.password), "Please enter valid password.")
            approvable &= this.approveItem(state.password === state.confirmPassword, "Your passwords do not match.")

        }

        return approvable;
        
    }

    getApprovableSubmit(state) {
        var approvable = true;

        if (state) {
            this.reasons = [];

            approvable &= this.approveItem(isValid(state.firstname), "Please enter valid first name.")
            approvable &= this.approveItem(isValid(state.lastname), "Please enter valid last name.")
            approvable &= this.approveItem(this.isValid(state.confirmationcode), "Please enter the confirmation code that you received via email.")
            approvable &= this.approveItem(isValidEmail(state.email), "Please enter valid email address.")
            approvable &= this.approveItem(isValidPassword(state.password), "Please enter valid password.")
            approvable &= this.approveItem(state.password === state.confirmPassword, "Your passwords do not match.")

        }

        return approvable;
        
    }

    componentDidMount() {
        this.setState({loading: false});
    }

    render () {
        if (this.state.loading) { return null; }
        
        stopTimer(); 
        return (
            <div>
                <Breadcrumb title={'Register'}/>
                                
                {/*Regsiter section*/}
                <section className="register-page section-b-space">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-lg-8 offset-lg-2">
                                <h3>create account (free)</h3>
                                <div className="theme-card ">
                                    <AvForm id="registerForm" className="theme-form" onValidSubmit={this.onValidSubmit} onInvalidSubmit={this.onInvalidSubmit} >
                                    <p>Please note: email address should be all lowercase.  Both email address and password are case sensitive.</p>
                                        <div className="form-row">
                                            <div className="col-md-6">
                                                <label htmlFor="email">email address</label>
                                                <AvField onChange={this.handleChange} required="" name="email" type="email" defaultValue={this.state.em} className="form-control" placeholder="Email" />
                                            </div>
                                            <div className="col-md-6">
                                            <br/>
                                                <p> Your username will be your valid email address. </p>
                                            </div>
                                        </div>
                                        
                                        <div className="form-row">
                                            <div className="col-md-6">
                                                <label htmlFor="firstname">First Name</label>
                                                <AvField onChange={this.handleChange} type="text" className="form-control" id="firstname" name="firstname" placeholder="First Name" required="" />
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="lastname">Last Name</label>
                                                <AvField onChange={this.handleChange} type="text" className="form-control" id="lastname" name="lastname" placeholder="Last Name" required="" />
                                            </div>
                                        </div>

                                        <div className="form-row">
                                            <div className="col-md-6">
                                                <label htmlFor="password">Password</label>
                                                <AvField onChange={this.handleChange} type="password" className="form-control" id="password" name="password" placeholder="Enter your password" required="" />
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="confirmPassword">Confirm Password</label>
                                                <AvField onChange={this.handleChange} type="password" className="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm your password" required="" />
                                            </div>
                                        </div>
                                        

                                        <div className="form-row">
                                            <div className="col-md-12">
                                                <p>Passwords must be at least 4 characters long.</p>
                                                <p>Enter information above and click the Send Code button.  Once you receive the code, enter the code and click the Create Account Button (which will appear.)</p>
                                            </div>
                                        </div>                                        

                                        <hr />

                                        <div className="form-row"> 
                                            <div className="col-md-6">
                                                <label htmlFor="confirmationcode">Confirmation Code</label>
                                                <AvField onChange={this.handleChange} type="text" className="form-control" id="confirmationcode" name="confirmationcode" placeholder="Enter code that was emailed" required="" />
                                            </div>                                           
                                            <div className="col-md-6" >
                                            {this.state.confirmationcode && this.state.confirmationcode.length === 6 
                                            ?    <Button disabled={!this.getApprovableSubmit(this.state)} type="submit" className="btn btn-solid pull-right">Create Account</Button>
                                            :    <Button disabled={!this.getApprovableCode(this.state)} type="submit" className="btn btn-solid pull-right">Send Code</Button>
                                            }
                                            </div>                                           
                                        </div> 
                                        {this.reasons.length > 0 &&
                                        <div className="row align-self-right text-right">
                                            <div className="col-lg-12 col-sm-12">
                                                <br/>
                                                <p>To submit, please attend to the following situations ...</p>
                                                {this.reasons.map(x=>
                                                <div ><p style={{fontSize: "14px", color: "red", lineHeight: "1.2em"}}>{x}</p></div>
                                                )}

                                            </div>                               
                                        </div>
                                        }
                                    </AvForm>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {this.state.openId === "1" && 
                    <ModalWindow title="Subscriptions" open={this.state.open} onCancel={this.onCancel}
                        content="Please create a free, simple account in order to manage your subscription"
                        commands={[
                            {title: "Ok", handler: this.onCancel}
                        ]}
                    />
                }
            </div>
        )
    }
}

export default Register